import styled from 'styled-components';

export const TextCardBox = styled.div`
  -moz-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: inline-block;
  height: 100%;
  width: 80%;
  max-width: 750px;
  padding: 30px;
  margin: 0 15px;
  margin-bottom: 30px;
  text-align: left;
  white-space: pre-wrap;
  .title {
    font-size: 20px;
    font-weight: bold;
    color: var(--logo-orange);
  }
  .content {
    line-height: 25px;
  }
  .business_kor {
    font-size: 20px;
    font-weight: bold;
    color: var(--logo-orange);
  }
  .business_eng {
    font-weight: bold;
    line-height: 25px;
  }
`;
